import { animate } from '../utils/animation'
import { animatePie } from './animate-pie'

export const initializePieDiagram = (diagram, diagramType, highlight, highlightValue, decimals, locale) => {
  diagram.style.paddingBottom = diagram.querySelector('.pie-legend').clientHeight + 20 + 'px'

  const { pieItems, pie } = initializePieItems(diagram, diagramType)

  const callback = (entries) => {
    animateBasedOnIntersectionRatio(entries, highlight, highlightValue, decimals, locale, pieItems, pie)
  }

  const observer = new IntersectionObserver(callback, { threshold: [0, 0.75] })
  observer.observe(diagram)
}

const initializePieItems = (diagram, diagramType) => {
  const pieItems = diagram.querySelectorAll('.pie-legend-item')
  const pie = diagram.querySelector('.pie')

  setPieBackground(diagramType, pieItems, pie)
  setPieColors(pieItems, pie)
  return { pieItems, pie }
}

const setPieBackground = (diagramType, pieItems, pie) => {
  const gradient = getInitialGradient(pieItems, pie)
  let pieBackground
  if (diagramType == 'donut') {
    pieBackground = `radial-gradient(white 35%, transparent 0 70%, white 0), conic-gradient(from 30deg, ${gradient}, white 0 100%)`
  } else {
    pieBackground = `conic-gradient(from 30deg, ${gradient})`
    pie.style.borderRadius = '50%'
  }

  pie.style.background = pieBackground
}

const getInitialGradient = (pieItems, pie) => {
  let gradientString = ''

  pieItems.forEach((item, idx) => {
    const itemJSON = JSON.parse(item.dataset.item)
    pie.style.setProperty(`--pie-size-${idx + 1}`, 0)
    if (idx + 1 == pieItems.length) {
      gradientString += `var(--pie-color-${idx + 1}) 0 var(--pie-size-${idx + 1})`
    } else {
      gradientString += `var(--pie-color-${idx + 1}) 0 var(--pie-size-${idx + 1}), `
    }
  })
  return gradientString
}

const setPieColors = (pieItems, pie) => {
  let items = pieItems.length

  pieItems.forEach((item, idx) => {
    const itemJSON = JSON.parse(item.dataset.item)
    if (!itemJSON.color) {
      itemJSON.color = getColorOnHueCircle(idx, items)
    }
    item.style.setProperty('--legend-item-color', itemJSON.color)
    pie.style.setProperty(`--pie-color-${idx + 1}`, itemJSON.color)
  })
}

const getColorOnHueCircle = (step, items) => {
  let stepSize = 360 / items
  let hue = Math.floor(step * stepSize)
  return `hsl(${hue}, 90%, 60%)`
}

const animateBasedOnIntersectionRatio = (entries, highlight, highlightValue, decimals, locale, pieItems, pie) => {
  if (!entries || !entries[0]) return

  const entry = entries[0]
  if (entry.isIntersecting && entry.intersectionRatio >= 0.75 && !(highlight && highlight.innerText != 0)) {
    if (highlight) {
      animate(highlight, 200, highlightValue, decimals, locale)
    }
    animatePie(pieItems, pie)
  } else if (entry.intersectionRatio == 0) {
    if (highlight) {
      highlight.innerText = 0
    }
  }
}
